<template>
  <div>
    <div class="page_mulu content">
       <div class="echarts aa">
          <div class="list_warp">
             <ul class="list_left">
               <li>
                 <p>外向(E)</p>
                 <div class="bi_warp">
                    <div class="bi_bg">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <div class="bi_bg2" :class="mbti.waixiang-mbti.neixiang > 0?'blueZ':'blueQ'" :style="{width: (30 - (30 - mbti.waixiang))/30*300 + 'px'}">
                      <span>{{mbti.waixiang}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>实感(S)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.ganjue-mbti.zhijue > 0?'orgZ':'orgQ'" :style="{width: (30 - (30 - mbti.ganjue ))/30*300 + 'px',}">
                      <span>{{mbti.ganjue}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>思考(T)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.sikao-mbti.qinggan > 0?'greenZ':'greenQ'" :style="{width: (30-( 30-mbti.sikao ))/30*300 + 'px',}">
                      <span>{{mbti.sikao}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>判断(J)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.panduan-mbti.zhijueb > 0?'zblueZ':'zblueQ'" :style="{width: (30-( 30-mbti.panduan ))/30*300 + 'px',}">
                      <span>{{mbti.panduan}}</span>
                    </div>
                 </div>
               </li>
             </ul>
              <ul class="list_right">
               <li>
                 <p>内向(I)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.waixiang-mbti.neixiang < 0 ?'blueZ':'blueQ' && mbti.waixiang==mbti.neixiang ?'blueZ':'blueQ'" :style="{width: (30-( 30-mbti.neixiang ))/30*300 + 'px',}">
                      <span :style="{marginLeft: (30-(30-mbti.neixiang ))/30*300+10 + 'px'}">{{mbti.neixiang}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>直觉(N)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.ganjue-mbti.zhijue < 0?'orgZ':'orgQ' && mbti.ganjue==mbti.zhijue?'orgZ':'orgQ'" :style="{width: (30-( 30-mbti.zhijue ))/30*300 + 'px'}">
                      <span :style="{marginLeft: (30-(30-mbti.zhijue ))/30*300+10 + 'px'}">{{mbti.zhijue}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>情感(F)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.sikao-mbti.qinggan < 0?'greenZ':'greenQ' && mbti.sikao==mbti.qinggan?'greenZ':'greenQ'" :style="{width: (30-(30-mbti.qinggan ))/30*300 + 'px'}">
                      <span :style="{marginLeft: (30-(30-mbti.qinggan ))/30*300+10 + 'px'}">{{mbti.qinggan}}</span>
                    </div>
                 </div>
               </li>
                <li>
                 <p>知觉(P)</p>
                 <div class="bi_warp">
                    <div class="bi_bg"></div>
                    <div class="bi_bg2" :class="mbti.panduan-mbti.zhijueb < 0?'zblueZ':'zblueQ' && mbti.panduan == mbti.zhijueb?'zblueZ':'zblueQ'" :style="{width: (30-( 30-mbti.zhijueb ))/30*300 + 'px',}">
                      <span :style="{marginLeft:(30-(30-mbti.zhijueb ))/30*300+10 + 'px',}">{{mbti.zhijueb}}</span>
                    </div>
                 </div>
               </li>
             </ul>
          </div>
          <div class="over">
            <div class="over-left">
                <p>你的人格类型是</p>
                <p>{{mbti.fourYard}}</p>
            </div>
            <div class="over-right">
                <p>你的人格极性指数为</p>
                <p>{{mbti.polarityIndex}}</p>
            </div>
          </div>
          <p class="over_jie">（极性指数范围从0-100，表示你的人格子维度得分在测验的内部一致性。得分低于25意味着有很多评分处于中间区域，可能是因为随意回答、缺乏自我认识，或是由于现实情境等的影响，在使用一个方面功能的实际频率或习惯程度并没有非常显著，不足以和另一功能的使用情况有明显差别。）</p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    mbti: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mounted() {
    // this.drawLine()
  },
  methods: {
    drawLine() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("line"));
      myChart.setOption({});
    },
  },
};
</script>

<style scoped>
@import "./report.css";
/* .list_warp {
  display: flex;
}
.over {
  display: flex;
  justify-content: space-around;
  margin: 30px 0;
} */
.list_warp{
    display: flex;
    justify-content: center;
}
.over{
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin: 30px 0;
}
.over-left,
.over-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.over-left p:first-child,
.over-right p:first-child {
  font-size: 14px;
  font-weight: 600;
}
.over-left p:last-child,
.over-right p:last-child {
  font-size: 20px;
  font-weight: 600;
}
.over-left p:last-child {
  color: #1ca4b6;
}
.over-right p:last-child {
  color: #f6a724;
}
.over_jie {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 30px;
  line-height: 2;
}

.echarts {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

ul.list_left .bi_bg {
  width: 300px;
  background: #e6e6e6;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
}
/* ul.list_left .bi_bg div{
  width: 75px;
  height: 40px;
  border-right: 1px dashed #E0DEDE;
  z-index: 2;
} */
ul.list_left .bi_bg2 {
  /* background: #1ca4b6; */
  height: 40px;
  width: 300px;
  position: absolute;
  right: 0;
  top: 0;
}
ul.list_left .bi_bg2 span {
  line-height: 40px;
  /* margin-right: -61px; */
  display: inline-block;
  margin-left: -25px;
}
ul.list_left .bi_warp {
  position: relative;
  width: 300px;
}
.echarts ul.list_left li {
  width: 356px;
  display: flex;
  height: 40px;
  margin-top: 15px;
  border-right: 1px solid #e1dfdf;
}
.echarts ul.list_left li p {
  height: 40px;
  line-height: 40px;
  width: 56px;
}

ul.list_right .bi_bg {
  width: 300px;
  background: #e6e6e6;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
ul.list_right .bi_bg2 {
  /* background: #1ca4b6; */
  height: 40px;
  width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}
ul.list_right .bi_bg2 span {
  line-height: 40px;
  /* margin-right: -61px; */
  display: inline-block;
}
ul.list_right .bi_warp {
  position: relative;
  width: 300px;
}
.echarts ul.list_right li {
  width: 356px;
  display: flex;
  flex-direction: row-reverse;
  height: 40px;
  margin-top: 15px;
}
.echarts ul.list_right li p {
  height: 40px;
  line-height: 40px;
  width: 56px;
  text-align: right;
}
.blueQ{
  background: rgb(78, 182, 197);
}
.blueZ{
  background: #1ca4b6;
}
.orgZ{
  background: #F6A724;
}
.orgQ{
  background: #F7B957;
}
.greenZ{
  background: rgb(164, 200, 0);
}
.greenQ{
background: rgb(197, 228, 25);
}
.zblueZ{
  background: #00AAE4;
}
.zblueQ{
  background: #25C2F3;
}


h5.page_bg_o {
  background-color: #19b1c4;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.page_title_2 .arrow {
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin: 40px 0 30px 0;
}

#line {
  width: 100%;
  height: 300px;
}

.page_js {
  /* margin-top: 80px; */
  margin-bottom: 40px;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 15px 15px;
  box-sizing: border-box;
  position: relative;
}
.page_js ul li {
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_js p {
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_zyjs {
  width: auto;
  padding: 0 15px;
  height: 30px;
  background: #3ab3c1;
  border-radius: 6px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -15px;
}
.page_js .page_bg_b {
  background: #3ab3c1;
}
.page_js .page_bg_o {
  background: #feae3b;
}
.page_js .page_bg_bl {
  background: #00b3f0;
}
.page_js .page_bg_g {
  background: #aacf00;
}
.page_js2 .page_co_o {
  color: #feae3b;
}
.page_js2 {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.page_js2 .page_left,
.page_js2 .page_right {
  width: 334px;
  height: 230px;
}
.page_left {
  display: flex;
  background: url("/public/imgs/cepingreport/page_3_33.png")
  no-repeat;
  background-size: cover;
}
.page_right {
  display: flex;
  background: url("/public/imgs/cepingreport/page_3_34.png")
  no-repeat;
  background-size: cover;
}
.icon_warp {
  width: 101px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.item_text ul {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.item_text ul li {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  padding: 0 5px;
}
.icon_warp .mar_top {
  margin-top: 15px;
}
.icon_icon .cheng {
  display: inline-block;
  width: 42px;
  height: 42px;
  background: url("/public/imgs/cepingreport/page_3_31.png")
  no-repeat;
  background-size: cover;
}
.icon_icon .fa {
  display: inline-block;
  width: 42px;
  height: 42px;
  background: url("/public/imgs/cepingreport/page_3_32.png")
  no-repeat;
  background-size: cover;
}
</style>